import { cloneDeep, isEmpty, orderBy } from "lodash"

const getSortSetting = (columns) => {
    const sorters = {}
    for (const column of columns) {
        if (typeof column.getSortValue === "function") {
            sorters[column.key] = column.getSortValue
        }
    }
    return sorters
}

const injectValue4Sorting = (data, sorters) => {
    for (const record of data) {
        for (const [key, sorter] of Object.entries(sorters)) {
            record[`__d_${key}`] = !(key in record)
            record[`__v_${key}`] = record[key]
            record[key] = sorter(record)
        }
    }
}

const removeKeyInjected = (data, setting) => {
    for (const record of data) {
        for (const key of Object.keys(setting)) {
            if (record[`__d_${key}`]) {
                delete record[key]
            } else {
                record[key] = record[`__v_${key}`]
            }
            delete record[`__d_${key}`]
            delete record[`__v_${key}`]
        }
    }
}

export default function getSortedDataSource(dataSource, state, columns) {
    if (isEmpty(state)) return dataSource

    const keys = Object.keys(state)
    const orders = keys.map((key) => state[key])
    const sorters = getSortSetting(columns)
    if (isEmpty(sorters)) {
        return orderBy(dataSource, keys, orders)
    }
    const clonedList = cloneDeep(dataSource)
    injectValue4Sorting(clonedList, sorters)
    const sortedList = orderBy(clonedList, keys, orders)
    removeKeyInjected(sortedList, sorters)
    return sortedList
}
